// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { InventoryProjectionLine } from './inventory-projection-line';
import { Part } from './part';
import { PartLink } from './part-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InventoryProjectionLinePart extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created?: Date;
  deleted?: Date;
  inventoryProjectionLineId!: number;
  isAssembly!: boolean;
  partId?: number;
  partLinkId?: number;
  processed?: Date;
  quantity!: number;
  inventoryProjectionLine!: InventoryProjectionLine;
  part!: Part;
  partLink!: PartLink;
}

